<template>
  <div>
    <CrudList
      title="FAQ's"
      storeName="Faqs"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/additional_info"
      :breadcrumbs="[
        {
          text: 'Información y soporte',
          disabled: false,
          href: '/admin/faqs'
        },
        {
          text: `FAQ's`,
          disabled: false,
          href: '#'
        }
      ]"
    >

    <template v-slot:types="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <span v-for="(type, index) in item.type" :key="index">
            <span v-if="index != 0"><br></span>{{ type }}
          </span>
        </v-col>
      </v-row>
    </template>
      <template v-slot:answer="{ item }">
        <div class="table-cell-fixed description-cell">
          {{ item.answer }}
        </div>
      </template>

    </CrudList>
  </div>
</template>
<style>
.table-cell-fixed {
  min-height: 100px; /* altura mínima */
  max-height: 100px; /* altura fija */
  display: flex;
  align-items: center;
  overflow: hidden; /* evita desbordes */
}

.description-cell {
  font-size: 12px;       /* más pequeña */
  line-height: 1.2;      /* compacto */
  overflow-y: auto;      /* scroll si es muy larga */
  max-height: 100%;      /* respeta altura fija */
}
</style>
<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
